"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deNormalizePhotoDimensions = exports.normalizePhotoDimensions = exports.MAX_SIZE = void 0;
exports.MAX_SIZE = 2000;
const normalizePhotoDimensions = (dimensions, naturalWidth, naturalHeight) => {
    if (naturalHeight === null || naturalWidth === null) {
        return dimensions;
    }
    if (naturalHeight > exports.MAX_SIZE || naturalWidth > exports.MAX_SIZE) {
        const normalizedDimensions = Object.assign({}, dimensions);
        let MAX_WIDTH = exports.MAX_SIZE;
        let MAX_HEIGHT = exports.MAX_SIZE;
        if (naturalWidth >= naturalHeight) {
            const ratio = naturalHeight / naturalWidth;
            MAX_HEIGHT = exports.MAX_SIZE * ratio;
        }
        else {
            const ratio = naturalWidth / naturalHeight;
            MAX_WIDTH = exports.MAX_SIZE * ratio;
        }
        normalizedDimensions.x = Math.round((normalizedDimensions.x * naturalWidth) / MAX_WIDTH);
        normalizedDimensions.y = Math.round((normalizedDimensions.y * naturalHeight) / MAX_HEIGHT);
        normalizedDimensions.width = Math.round((normalizedDimensions.width * naturalWidth) / MAX_WIDTH);
        normalizedDimensions.height = Math.round((normalizedDimensions.height * naturalHeight) / MAX_HEIGHT);
        return normalizedDimensions;
    }
    return dimensions;
};
exports.normalizePhotoDimensions = normalizePhotoDimensions;
const deNormalizePhotoDimensions = (dimensions, naturalWidth, naturalHeight) => {
    if (naturalHeight === null || naturalWidth === null) {
        return dimensions;
    }
    if (naturalHeight > exports.MAX_SIZE || naturalWidth > exports.MAX_SIZE) {
        const normalizedDimensions = Object.assign({}, dimensions);
        let MAX_WIDTH = exports.MAX_SIZE;
        let MAX_HEIGHT = exports.MAX_SIZE;
        if (naturalWidth >= naturalHeight) {
            const ratio = naturalHeight / naturalWidth;
            MAX_HEIGHT = exports.MAX_SIZE * ratio;
        }
        else {
            const ratio = naturalWidth / naturalHeight;
            MAX_WIDTH = exports.MAX_SIZE * ratio;
        }
        normalizedDimensions.x = Math.round((normalizedDimensions.x / naturalWidth) * MAX_WIDTH);
        normalizedDimensions.y = Math.round((normalizedDimensions.y / naturalHeight) * MAX_HEIGHT);
        normalizedDimensions.width = Math.round((normalizedDimensions.width / naturalWidth) * MAX_WIDTH);
        normalizedDimensions.height = Math.round((normalizedDimensions.height / naturalHeight) * MAX_HEIGHT);
        return normalizedDimensions;
    }
    return dimensions;
};
exports.deNormalizePhotoDimensions = deNormalizePhotoDimensions;
